import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bottom-footer',
  templateUrl: './bottom-footer.component.html',
  styleUrls: ['./bottom-footer.component.scss']
})
export class BottomFooterComponent implements OnInit {

  year: number = new Date().getFullYear()

  constructor() { }

  ngOnInit() { }

}
